// src/api.js
import axios from "axios";

// Бере базову адресу бекенду з CRA env або падає на локалку
// Приклад для прод: REACT_APP_API_URL=https://your-backend.onrender.com
const API_BASE = (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/$/, "");

// У більшості роутів у тебе префікс /api, тож додамо його тут
const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: false, // не шлемо cookie, щоб уникнути CORS-проблем
  timeout: 30000,
});

// Додаємо Bearer-токен до кожного запиту, якщо він є
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Глобальна обробка 401 (опційно)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // Токен прострочений/некоректний — чистимо й, за потреби, редіректимо на /login
      localStorage.removeItem("token");
      // window.location.href = "/login"; // розкоментуй, якщо треба автолог-аут
    }
    return Promise.reject(err);
  }
);

export default api;
